import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import update from 'immutability-helper';
import debounce from 'lodash.debounce';
import Form from './Form';
import './GroupParentForm.scss';
import { analyticsTrack } from '../../../analyticsUtils';

class GroupParentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      answers: props.answers,
    };
    this.handleAddForm = this.handleAddForm.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.handleDeleteForm = this.handleDeleteForm.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFormAndMenuUpdate = debounce(this.handleFormAndMenuUpdate.bind(this), 500);
    this.renderAddButtonText = this.renderAddButtonText.bind(this);
  }

  componentDidMount() {
    const { answers } = this.state;
    if (answers.length === 0) { this.handleAddForm(); }
  }

  handleInputChange(value, columnName, index) {
    const { answers } = this.state;
    const innerIndex = answers[index].findIndex((a) => a.column_name === columnName);
    const newAnswers = update(answers, { [index]: { [innerIndex]: { value: { $set: value } } } });
    this.setState({ errors: [] });
    this.handleValidation();
    this.setState({ answers: newAnswers }, this.handleFormAndMenuUpdate);
  }

  handleFormAndMenuUpdate() {
    const { handleMenuUpdate, onboardingQuestionnaire } = this.props;

    if (onboardingQuestionnaire) {
      this.handleSubmit();
      handleMenuUpdate(true);
    }
  }

  handleAddForm() {
    const { answers } = this.state;
    const {
      childrenQuestions, onboardingQuestionnaire, userId, questionKey,
    } = this.props;
    const newGrouping = Object.assign([], childrenQuestions);
    newGrouping.forEach((_a, index) => { newGrouping[index].value = null; });
    const newAnswers = update(answers, { $push: [newGrouping] });

    analyticsTrack(`${this.renderAddButtonText}`, {
      location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Not Onboarding Flow',
      questionKey,
      userId,
    });
    this.setState({ answers: newAnswers });
  }

  handleDeleteForm(index) {
    const { answers } = this.state;
    const { questionKey, userId, onboardingQuestionnaire } = this.props;

    answers.splice(index, 1);

    analyticsTrack(`Remove ${questionKey}`, {
      location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Not Onboarding Flow',
      questionKey,
      userId,
    });
    this.setState({ answers }, () => {
      if (answers.length === 0) {
        this.handleAddForm();
      }
      this.setState({ errors: this.handleValidation() });
      this.handleFormAndMenuUpdate();
    });
  }

  handleSubmit() {
    const { answers } = this.state;
    const { handleChange, questionKey, closeModal } = this.props;
    const errors = this.handleValidation();
    if (errors.filter((e) => e.length > 0).length === 0) {
      handleChange(answers, questionKey, null, false).then(() => closeModal());
    } else {
      this.setState({ errors });
    }
  }

  handleValidation() {
    const { disabled } = this.props;
    if (disabled) return [];
    const { answers } = this.state;
    if (answers.length === 1) {
      const filledForm = answers[0].filter((qa) => qa.value).length > 0;
      if (!filledForm) {
        return [];
      }
    }
    return answers.map((answer) => {
      const error = [];
      const association = answer.find((a) => a.question_type === 'select_one' && a.style === 'multiselect');
      if (association.value === null && association.question_key !== 'education_degree_id') {
        error.push(association.column_name.replace('_id', ''));
      }
      return error;
    });
  }

  renderForm() {
    const {
      childrenQuestions, disabled, onboardingQuestionnaire, questionKey,
    } = this.props;
    const { answers, errors } = this.state;
    return (
      <Fragment>
        {answers.map((answer, index) => (
          <Form
            questions={childrenQuestions}
            answers={answer}
            index={index}
            handleInputChange={this.handleInputChange}
            handleDelete={this.handleDeleteForm}
            errors={errors[index] || []}
            disabled={disabled}
            onboardingQuestionnaire={onboardingQuestionnaire}
            questionKey={questionKey}
            formCount={answers.length}
          />
        ))}
      </Fragment>
    );
  }

  renderAddButtonText() {
    const { questionKey } = this.props;
    let text = `Add another ${questionKey}`;
    if (questionKey === 'education') {
      text = 'Add degree';
    } else if (questionKey === 'language') {
      text = `Add ${questionKey}`;
    }

    return text;
  }

  render() {
    const { questionKey, disabled, onboardingQuestionnaire } = this.props;
    return (
      <div className={`group-parent-question ${questionKey} body-text-2`}>
        {this.renderForm()}
        <div>
          <button
            type="button"
            className="btn btn-link text-decoration-none"
            id="add-new-item"
            onClick={() => this.handleAddForm()}
            disabled={disabled}
          >
            <i className="fa fa-plus mr-5" />
            {this.renderAddButtonText()}
          </button>
        </div>
        {
          !onboardingQuestionnaire
            && (
            <div className="buttons-bar">
              <Button
                variant="primary"
                id="save-group-parent"
                className="save"
                onClick={this.handleSubmit}
              >
                Save
              </Button>
            </div>
            )
        }
      </div>
    );
  }
}

GroupParentForm.propTypes = {
  answers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  questionKey: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  childrenQuestions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  closeModal: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  userId: PropTypes.string.isRequired,
  handleMenuUpdate: PropTypes.func.isRequired,
  onboardingQuestionnaire: PropTypes.bool,
};

GroupParentForm.defaultProps = {
  disabled: false,
  onboardingQuestionnaire: false,
};

export default GroupParentForm;
